module.exports = __webpack_public_path__ + "img/Endra-Masagung-2.450b916f.png";